export default {
    NAO_RECEBE: {
        id: "NAO_RECEBE",
        nome: "Não recebe",
    },
    VIA_EMAIL: {
        id: "VIA_EMAIL",
        nome: "Via email",
    }
}